import {Component, ComponentFactoryResolver, inject, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ChatbotSettingsComponent} from "../../../chatbots/settings/chatbot-settings.component";
import {AssistantSettingsComponent} from "../../../assistants/settings/assistant-settings/assistant-settings.component";
import {TaskSettingsComponent} from "../../../tasks/settings/task-settings/task-settings.component";
import {
    FunctionSettingsComponent
} from "../../../functions/function-settings/function-settings/function-settings.component";
import {FileSettingsComponent} from "../../../files/files-settings/file-settings/file-settings.component";
import {
    ProductFeedSettingsComponent
} from "../../../product-feeds/product-feeds-settings/product-feed-settings/product-feed-settings.component";
import {WorkflowSettingsComponent} from "../../../workflows/settings/workflow-settings/workflow-settings.component";

@Component({
  selector: 'app-detail-loader',
  template: `<ng-template #detailContainer></ng-template>`,
})
export class DetailLoaderComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private resolver = inject(ComponentFactoryResolver);

  @ViewChild('detailContainer', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  ngOnInit(): void {
    const type = this.route.snapshot.paramMap.get('type');
    let component: any;

    switch (type) {
      case 'chatbots':
        component = ChatbotSettingsComponent;
        break;
      case 'assistants':
        component = AssistantSettingsComponent;
        break;
      case 'workflows':
        component = WorkflowSettingsComponent;
        break
      case 'tasks':
        component = TaskSettingsComponent;
        break
      case 'product-feeds':
        component = ProductFeedSettingsComponent;
        break;
      case 'functions':
        component = FunctionSettingsComponent;
        break;
      case 'files':
        component = FileSettingsComponent;
        break;
        // Add more cases as needed
      default:
        throw new Error(`Unknown type: ${type}`);
    }

    const factory = this.resolver.resolveComponentFactory(component);
    this.container.clear();
    this.container.createComponent(factory);
  }
}
